/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { defineRecipe } from 'chakra-v3';

/**
 * Link Recipe - Styling variants for link components
 */
export const linkRecipe = defineRecipe({
  base: {
    fontFamily: 'body',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'opacity 0.2s',
  },
  variants: {
    variant: {
      whatsapp: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        color: 'brand.secondaryBlue2',
        fontSize: { base: '18px', md: '20px' },
        fontWeight: '600',
        fontFamily: 'body',
        lineHeight: '1.4',
        letterSpacing: '0.1px',
        _hover: {
          opacity: 0.8,
          textDecoration: 'none',
        },
        _active: {
          opacity: 0.6,
        },
      },
      plain: {
        // Plain link variant - no special styling, used in navigation menus
        textDecoration: 'none',
        _hover: {
          textDecoration: 'none',
        },
      },
      underline: {
        // Underlined link variant - used in footer and external links
        textDecoration: 'underline',
        _hover: {
          textDecoration: 'underline',
        },
      },
      footer: {
        // Footer navigation link - primary text color with accent hover
        color: 'text.primary',
        cursor: 'pointer',
        textDecoration: 'none',
        _hover: {
          color: 'text.accent',
          textDecoration: 'none',
        },
      },
      card: {
        // Card container link - full width, no decoration, block display
        textDecoration: 'none',
        width: '100%',
        display: 'block',
        _hover: {
          textDecoration: 'none',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'plain',
  },
});
